import React from "react";

import {
  List,
  ListItem
} from "@patternfly/react-core";

const BranchQualifications = ({ qualifications }) => {
  if (!qualifications.length) {
    return null;
  }

  return (
    <List>
      {qualifications.map((qualification) => (
        <ListItem key={qualification.qualification_symbol}>
          <strong>
            {qualification.qualification_symbol}
          </strong>{" "}
          {qualification.qualification_name}
        </ListItem>
      ))}
    </List>
  );
};

export default BranchQualifications;